import request from '@/router/axios';

// 列表 - 使用变动日志接口
export const getList = (params) => {
  return request({
    url: '/api/produce/base-spare-part-change-log/select/page',
    method: 'post',
    data: params
  })
}

// 详情 - 根据ID查询变动日志
export const getDetail = (id) => {
  return request({
    url: '/api/produce/base-spare-part-change-log/select/id',
    method: 'get',
    params: { id }
  })
}
